<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Supervisor Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense class="px-3 pt-2">
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="exam_plan" item-value="id"
                        :items="exam_plan_list" item-text="plan_name" label="Exam Plan *" outlined
                        persistent-hint hint="Please Select Exam Plan" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="exam_room" item-value="id"
                        :items="room_list" item-text="room_number" label="Exam Room *" outlined persistent-hint
                        hint="Please Select Exam Room" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="supervisor" item-value="id"
                        :items="supervisor_list" item-text="employee_name" label="Supervisor *" outlined persistent-hint
                        hint="Please Select Supervisor" />
                </v-col>
                <v-col cols="12" sm="2" md="2" class="pt-1 pl-2" v-if="isFetchValid">
                    <v-btn color="primary" @click="fetchSupervisorReport()" rounded small class="mt-2">
                        <v-icon left>mdi-magnify</v-icon> Fetch
                    </v-btn>
                </v-col>
            </v-row>
            <br>
            <!-- <v-data-table :headers="headers" :items="supervisor_report" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-row dense class="px-3">
                        <v-col cols="12" sm="6" md="5">
                            <v-btn rounded color="success" outlined :loading="loader" :disabled="!supervisor_report.length"
                                @click="downloadFile" small class="mt-2">
                                <v-icon left color="success">mdi-file-excel</v-icon>
                                Export Excel
                            </v-btn>

                            <v-btn rounded color="error" outlined :disabled="!supervisor_report.length"
                                @click="printPDF" small class="mt-2 ml-2">
                                <v-icon left color="error">mdi-file-pdf-box</v-icon>
                                Export PDF
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col sm="6" md="5" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search report..." single-line
                                hide-details dense></v-text-field>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table> -->
            <div  v-if="reportFetched">
            <v-row dense align="center">
                 <v-col cols="auto" class="pa-0">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile" small
                                class="mt-2 ml-2">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export EXCEL
                            </v-btn>
                        </v-col>

                        <v-col cols="auto" class="pa-0 pl-1">
                            <v-btn rounded color="error" outlined @click="printPDF" small class="mt-2">
                                <v-icon left color="error">mdi-file-pdf-box</v-icon>
                                Export PDF
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>

                        <!-- <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col> -->
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        clearable
                        class="search-field"
                    ></v-text-field>

                    </v-row>
                    <v-row >
                            <v-col cols="12" sm="" md="2" align="center">
                                <img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                            <v-col cols="12" sm="8" md="8" align="center">
                                <h2 v-if="org_basic_data.trust_name" class="trust_name" >
                                    {{ org_basic_data.trust_name }}
                                </h2>
                                <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name" class="school_name">
                                    {{ org_basic_data.school_name }}</h2>
                                <!-- <h4 style="text-transform: uppercase;" class="scheme_name"> {{ ass_Scheme }} - {{ academicyear }} </h4> -->
                                <h3 class="report_name">Supervisor Report</h3>
                               
                            </v-col>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                        </v-row>
                         <v-simple-table  fixed-header height="500px" dense class="elevation-1 scroll table-data">
                           <thead>
                                <tr>
                                    <th class="sticky-header"><center>S. No.</center></th>
                                    <th class="sticky-header"><center>Session No.</center></th>
                                    <th class="sticky-header"><center>Exam Date</center></th>
                                    <th class="sticky-header"><center>Exam Day</center></th>
                                    <th class="sticky-header"><center>Slot No</center></th>
                                    <th class="sticky-header"><center>From Time</center></th>
                                    <th class="sticky-header"><center>To Time</center></th>
                                    <th class="sticky-header"><center>Subject Code</center></th>
                                    <th class="sticky-header"><center>Subject Name</center></th>
                                    <th class="sticky-header"><center>Conduct Type</center></th>
                                    <th class="sticky-header"><center>Room No</center></th>
                                    <th class="sticky-header"><center>Standard</center></th>
                                    <th class="sticky-header"><center>Stream</center></th>
                                    <th class="sticky-header"><center>Supervisor</center></th>
                                    <th class="sticky-header"><center>Exam Plan</center></th>
                                    <th class="sticky-header"><center>Academic Year</center></th>
                                    <th class="sticky-header"><center>Semester</center></th>

                                </tr>
                            </thead>
                    <tbody>
                    <tr v-for="(s, index) in filteredSupervisorReport" :key="s.cid || index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ s.session_no }}</td>
                        <td>{{ s.exam_date }}</td>
                        <td>{{ s.exam_day }}</td>
                        <td>{{ s.slot_no }}</td>
                        <td>{{ s.from_time }}</td>
                        <td>{{ s.to_time }}</td>
                        <td>{{ s.subject_code }}</td>
                        <td>{{ s.subject_name }}</td>
                        <td>{{ s.conduct_type }}</td>
                        <td>{{ s.room_no }}</td>
                        <td>{{ s.standard }}</td>
                        <td>{{ s.stream }}</td>
                        <td>{{ s.supervisor }}</td>
                        <td>{{ s.exam_name }}</td>
                        <td>{{ s.ay }}</td>
                        <td>{{ s.semester }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
            </div>

        <div id="pdf-report" class="pdf-report">
             <v-row >
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                            <v-col cols="12" sm="8" md="8" align="center">
                                <h2 v-if="org_basic_data.trust_name" class="trust_name" >
                                    {{ org_basic_data.trust_name }}
                                </h2>
                                <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name" class="school_name">
                                    {{ org_basic_data.school_name }}</h2>
                                <!-- <h4 style="text-transform: uppercase;" class="scheme_name"> {{ ass_Scheme }} - {{ academicyear }} </h4> -->
                                <h2 class="report_name">Supervisor Report</h2>
                               
                            </v-col>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                        </v-row>
            <table>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Session No.</th>
                        <th>Exam Date</th>
                        <th>Exam Day</th>
                        <th>Slot No</th>
                        <th>From Time</th>
                        <th>To Time</th>
                        <th>Subject Code</th>
                        <th>Subject Name</th>
                        <th>Conduct Type</th>
                        <th>Room No.</th>
                        <th>Standard</th>
                        <th>Stream</th>
                        <th>Supervisor</th>
                        <th>Exam Plan</th>
                        <th>Academic Year</th>
                        <th>Semester</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in supervisor_report" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.session_no }}</td>
                        <td>{{ item.exam_date }}</td>
                        <td>{{ item.exam_day }}</td>
                        <td>{{ item.slot_no }}</td>
                        <td>{{ item.from_time }}</td>
                        <td>{{ item.to_time }}</td>
                        <td>{{ item.subject_code }}</td>
                        <td>{{ item.subject_name }}</td>
                        <td>{{ item.conduct_type }}</td>
                        <td>{{ item.room_no }}</td>
                        <td>{{ item.standard }}</td>
                        <td>{{ item.stream }}</td>
                        <td>{{ item.supervisor }}</td>
                        <td>{{ item.exam_name }}</td>
                        <td>{{ item.ay }}</td>
                        <td>{{ item.semester }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

export default {
    name: "SupervisorReport",
    data: () => ({
        valid: false,
        overlay: false,
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        reportFetched: false,
        org_basic_data: [],
        search: "",
        dialog: false,
        exam_plan: null,
        exam_room: null,
        supervisor: null,
        headers: [
            { text: "S.No", align: "left", sortable: false, value: "srno" },
            { text: "Session No.", align: "left", sortable: true, value: "session_no" },
            { text: "Exam Date", align: "left", sortable: true, value: "exam_date" },
            { text: "Exam Day", align: "left", sortable: true, value: "exam_day" },
            { text: "Slot No", align: "left", sortable: true, value: "slot_no" },
            { text: "From Time", align: "left", sortable: true, value: "from_time" },
            { text: "To Time", align: "left", sortable: true, value: "to_time" },
            { text: "Subject Code", align: "left", sortable: true, value: "subject_code" },
            { text: "Subject Name", align: "left", sortable: true, value: "subject_name" },
            { text: "Conduct Type", align: "left", sortable: true, value: "conduct_type" },
            { text: "Room No.", align: "left", sortable: true, value: "room_no" },
            { text: "Standard", align: "left", sortable: true, value: "standard" },
            { text: "Stream", align: "left", sortable: true, value: "stream" },
            { text: "Supervisor", align: "left", sortable: true, value: "supervisor" },
            { text: "Exam Plan", align: "left", sortable: true, value: "exam_name" },
            { text: "Academic Year", align: "left", sortable: true, value: "ay" },
            { text: "Semester", align: "left", sortable: true, value: "semester" },
        ],
        exam_plan_list: [],
        room_list: [],
        supervisor_report: [],
        supervisor_list: [],
    }),

    computed: {
        isFetchValid() {
            return (
                this.exam_plan !== null &&
                this.exam_plan !== "" &&
                this.exam_room !== "" &&
                this.exam_room !== undefined &&
                this.supervisor !== undefined &&
                this.supervisor !== ""
            );
        },

        filteredSupervisorReport() {
            const data = this.supervisor_report || [];
            const query = (this.search || "").toLowerCase().trim();

            if (!query) {
                return data;
            }

            return data.filter(item =>
                Object.values(item).some(value =>
                    String(value == null ? "" : value)
                        .toLowerCase()
                        .includes(query)
                )
            );
        }
    },

    mounted() {
        this.onLoad();
    },

    methods: {
        onLoad() {
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getPlanAndRoomList")
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.exam_plan_list = res.data.exam_plan_list || [];
                        this.supervisor_list = res.data.supervisor_list || [];

                        const rawRooms = res.data.room_list || [];
                        this.room_list = [
                            { id: null, room_number: "All" },
                            ...rawRooms
                        ];

                        this.supervisor_list = [
                            { id: null, employee_name: "All" },
                            ...res.data.supervisor_list
                        ];

                        const savedPlan = localStorage.getItem("exam_plan");
                        if (savedPlan) {
                            this.exam_plan = Number(savedPlan);
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Failed to fetch dropdown list.");
                    }
                })
                .catch((err) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    console.error(err);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        

        // fetchSupervisorReport() {
        //     this.overlay = true;
        //     const data = {
        //         exam_plan: this.exam_plan,
        //         exam_room: this.exam_room,
        //         supervisor: this.supervisor
        //     };

        //     axios
        //         .post("/SeatingArrangement/fetchSupervisorReport", data)
        //         .then((res) => {
        //             if (res.data.msg === "200") {
        //                 this.supervisor_report = (res.data.supervisor_report || []).map((item, idx) => ({
        //                     ...item,
        //                     srno: idx + 1
        //                 }));
        //             } else {
        //                 this.showSnackbar("#e65100", res.data.msg || "No records found");
        //             }
        //         })
        //         .catch((error) => {
        //             this.showSnackbar("#b71c1c", "Something went wrong...");
        //             console.error(error);
        //         })
        //         .finally(() => {
        //             this.overlay = false;
        //         });
        // },
//         fetchSupervisorReport() {
//     this.overlay = true;
//     this.reportFetched = false;
//     this.org_basic_data = []

//     const data = {
//         exam_plan: this.exam_plan,
//         exam_room: this.exam_room,
//         supervisor: this.supervisor
//     };

//     console.log("Request data:", data);

//     axios
//         .post("/SeatingArrangement/fetchSupervisorReport", data)
//         .then((res) => {
//             console.log("Supervisor report response:", res.data);

//             if (res.data.msg === "200") {
//                 const report = res.data.supervisor_report || [];

//                 this.supervisor_report = report.map((item, idx) => ({
//                     ...item,
//                     srno: idx + 1
//                 }));

//                 this.reportFetched = true;

//                 if (this.supervisor_report.length === 0) {
//                     this.showSnackbar("#e65100", "No records found.");
//                 }
//             } else {
//                 this.supervisor_report = [];
//                 this.reportFetched = false;

//                 this.showSnackbar(
//                     "#e65100",
//                     res.data.msg || "No records found"
//                 );
//             }
//         })
//         .catch((error) => {
//             console.error("Supervisor report error:", error);
//             this.showSnackbar("#b71c1c", "Something went wrong...");
//         })
//         .finally(() => {
//             this.overlay = false;
//         });
// },

        fetchSupervisorReport() {
            this.overlay = true;
            this.reportFetched = false;
            this.supervisor_report = [];
            this.org_basic_data = [];

            const data = {
                exam_plan: this.exam_plan,
                exam_room: this.exam_room,
                supervisor: this.supervisor
            };

            axios
                .post("/SeatingArrangement/fetchSupervisorReport", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.supervisor_report = (
                            res.data.supervisor_report || []
                        ).map((item, index) => ({
                            ...item,
                            srno: index + 1
                        }));

                        this.org_basic_data = res.data.org_basic_data || [];

                        this.reportFetched = true;

                        if (this.supervisor_report.length === 0) {
                            this.showSnackbar("#e65100", "No data available.");
                        }
                    } else {
                        this.supervisor_report = [];
                        this.org_basic_data = [];
                        this.reportFetched = false;

                        this.showSnackbar(
                            "#b71c1c",
                            res.data.msg || "No data available."
                        );
                    }
                })
                .catch((error) => {
                    console.error("Supervisor Report Error:", error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        downloadFile() {
            this.loader = true;
            try {
                const excelData = this.supervisor_report.map((item, index) => ({
                    "S.No": index + 1,
                    "Session No": item.session_no,
                    "Exam Date": item.exam_date,
                    "Exam Day": item.exam_day,
                    "Slot No": item.slot_no,
                    "From Time": item.from_time,
                    "To Time": item.to_time,
                    "Subject Code": item.subject_code,
                    "Subject Name": item.subject_name,
                    "Conduct Type": item.conduct_type,
                    "Room No": item.room_no,
                    "Standard": item.standard,
                    "Stream": item.stream,
                    "Supervisor": item.supervisor,
                    "Exam Plan": item.exam_name,
                    "Academic Year": item.ay,
                    "Semester": item.semester
                }));

                const worksheet = XLSX.utils.json_to_sheet(excelData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Supervisor Report");
                XLSX.writeFile(workbook, "SupervisorReport.xlsx");
            } catch (err) {
                this.showSnackbar("#b71c1c", "Error exporting to Excel file.");
            } finally {
                this.loader = false;
            }
        },

        printPDF() {
            if (!this.supervisor_report || this.supervisor_report.length === 0) {
                this.showSnackbar("#b71c1c", "No data available for PDF export.");
                return;
            }

            window.print();
        },
    },
};
</script>

<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

::v-deep .mytable tbody tr td {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
}

.pdf-report {
    display: none;
}
</style>

<style>
/* @media print {
    @page {
        size: A3 landscape;
        margin: 5mm;
    }

    html,
    body,
    #app,
    .v-application,
    .v-application--wrap,
    .container {
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        background: #fff !important;
    }

    .v-card,
    .v-toolbar,
    .v-data-table,
    .v-overlay,
    .v-snack,
    .v-footer {
        display: none !important;
    }

    #pdf-report {
        display: block !important;
        visibility: visible !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        position: relative !important;
        float: none !important;
        page-break-after: avoid !important;
        break-after: avoid !important;
    }

    #pdf-report * {
        visibility: visible !important;
    }

    #pdf-report h2 {
        text-align: center;
        font-size: 14px;
        margin: 0 0 5px 0;
        padding: 0;
    }

    #pdf-report table {
        width: 100%;
        border-collapse: collapse;
        font-size: 8px;
        margin: 0;
    }

    #pdf-report th,
    #pdf-report td {
        border: 1px solid #000;
        padding: 2px 4px;
        text-align: center !important;
        vertical-align: middle !important;
        font-size: 12px;
    }

    #pdf-report thead {
        display: table-header-group;
    }

    #pdf-report tr {
        page-break-inside: avoid;
        break-inside: avoid;
    } */
/* } */
@media print {
    @page {
        size: A3 landscape;
        /* margin: 5mm; */
        margin-left: -40px;
    }

    html,
    body,
    #app,
    .v-application,
    .v-application--wrap {
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        background: #fff !important;
    }

    body * {
        visibility: hidden !important;
    }

    #pdf-report,
    #pdf-report * {
        visibility: visible !important;
    }

    #pdf-report {
        display: block !important;
        position: absolute !important;
        left: 0 !important;
        top: 0 !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        background: #fff !important;
    }

    #pdf-report .row {
        display: flex !important;
        flex-wrap: nowrap !important;
        align-items: center !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    #pdf-report .col {
        padding: 2px !important;
    }

    #pdf-report img {
        max-width: 65px !important;
        max-height: 65px !important;
        object-fit: contain !important;
    }

    #pdf-report h2 {
        font-size: 14px !important;
        text-align: center !important;
        margin: 2px 0 !important;
    }

    #pdf-report h3 {
        font-size: 12px !important;
        text-align: center !important;
        margin: 3px 0 6px !important;
    }

    #pdf-report table {
        width: 100% !important;
        border-collapse: collapse !important;
        table-layout: auto !important;
        font-size: 8px !important;
    }

    #pdf-report th,
    #pdf-report td {
        border: 1px solid #000 !important;
        padding: 3px 2px !important;
        text-align: center !important;
        vertical-align: middle !important;
        font-size: 16px !important;
        color: #000 !important;
        overflow-wrap: anywhere !important;
    }

    #pdf-report thead {
        display: table-header-group !important;
    }

    #pdf-report tr {
        break-inside: avoid !important;
        page-break-inside: avoid !important;
    }
    Header layout,
    #pdf-report .row {
        display: flex !important;
        flex-wrap: nowrap !important;
        align-items: center !important;
        width: 100% !important;
        margin: 0 0 8px 0 !important;
    }

    #pdf-report .col {
        padding: 4px !important;
    }

    #pdf-report img.print-logo {
        width: 100px !important;
        height: 100px !important;
        max-width: 100px !important;
        max-height: 100px !important;
        object-fit: contain !important;
    }

    #pdf-report h2.trust_name {
        font-size: 24px !important;
        font-weight: bold !important;
        text-align: center !important;
        line-height: 1.3 !important;
        margin: 4px 0 !important;
    }

    #pdf-report h2.school_name {
        font-size: 28px !important;
        font-weight: bold !important;
        text-align: center !important;
        line-height: 1.3 !important;
        margin: 4px 0 !important;
    }

    #pdf-report .report_name {
        font-size: 20px !important;
        font-weight: bold !important;
        text-align: center !important;
        margin: 6px 0 !important;
    }
 }
</style>